import React, { Component } from 'react';
import { BoxIcon } from 'lucide-react';
interface ComplianceCardProps {
  title: string;
  description: string;
  status: 'completed' | 'warning' | 'in-progress' | 'pending';
  icon: BoxIcon;
  action: {
    label: string;
    onClick: () => void;
  };
}
export const ComplianceCard = ({
  title,
  description,
  status,
  icon: IconComponent,
  action
}: ComplianceCardProps) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'completed':
        return {
          icon: '✔️',
          bgColor: 'bg-green-50',
          textColor: 'text-green-700',
          borderColor: 'border-green-200'
        };
      case 'warning':
        return {
          icon: '⚠️',
          bgColor: 'bg-amber-50',
          textColor: 'text-amber-700',
          borderColor: 'border-amber-200'
        };
      case 'in-progress':
        return {
          icon: '⏳',
          bgColor: 'bg-blue-50',
          textColor: 'text-blue-700',
          borderColor: 'border-blue-200'
        };
      default:
        return {
          icon: '📄',
          bgColor: 'bg-gray-50',
          textColor: 'text-gray-700',
          borderColor: 'border-gray-200'
        };
    }
  };
  const statusConfig = getStatusConfig(status);
  return <div className={`rounded-xl border ${statusConfig.borderColor} bg-white p-6 shadow-sm hover:shadow-md transition-shadow duration-200`} data-id="element-31">
      <div className="space-y-4" data-id="element-32">
        {/* Header */}
        <div className="flex justify-between items-start" data-id="element-33">
          <div className={`p-2 ${statusConfig.bgColor} rounded-lg`} data-id="element-34">
            <IconComponent className={`w-5 h-5 ${statusConfig.textColor}`} data-id="element-35" />
          </div>
          <span className="text-lg" data-id="element-36">{statusConfig.icon}</span>
        </div>
        {/* Content */}
        <div data-id="element-37">
          <h3 className="font-medium text-gray-900" data-id="element-38">{title}</h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-39">{description}</p>
        </div>
        {/* Action */}
        <button onClick={action.onClick} className="w-full px-4 py-2 text-sm font-medium rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors duration-150" data-id="element-40">
          {action.label}
        </button>
      </div>
    </div>;
};